import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, AnyAction } from 'redux'
import NoAvatar from 'header/no-avatar.png'
import { profileLoaded } from 'settings/actions'
import { AvatarLoader } from 'uiComponents/loaders'
import { AccountSettingsService } from 'settings/settingsService'
import { PageTopMessage, HeaderMessageContainer } from 'uiComponents/messages'
import { UserService } from 'auth/userService'
import { Headline } from 'uiComponents/typography'
import './personalSettingsHeader.scss'
import { t } from 'translations'

interface AccountSettingsProps {
    accountSettingsService: AccountSettingsService
    userService: UserService
    username: string
    avatarUrl: string
    profileLoaded: typeof profileLoaded
    actions?: React.ReactNode
}

interface AccountSettingsState {
    uploading: boolean
    errorMessage: string
    showErrorMessage: boolean
}

class AccountSettingsHeader extends React.Component<AccountSettingsProps, AccountSettingsState> {
    constructor(props: AccountSettingsProps) {
        super(props)
        this.state = {
            uploading: false,
            errorMessage: '',
            showErrorMessage: false,
        }
    }

    onFileSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist()
        if (e.target.files) {
            this.fileUpload(e.target.files[0])
        }
    }

    fileUpload = async (file: File) => {
        this.setState({
            errorMessage: '',
            showErrorMessage: false,
            uploading: true,
        })
        try {
            await this.props.accountSettingsService.avatarUpload(file)
            this.updateProfile()
        } catch (e) {
            this.setState({
                errorMessage: e.message,
                showErrorMessage: true,
                uploading: false,
            })
        }
    }

    updateProfile = async () => {
        const userDetails = await this.props.userService.getLoggedInUser()
        this.props.profileLoaded(userDetails.profile)
        this.setState({ uploading: false })
    }

    render() {
        const { uploading, errorMessage, showErrorMessage } = this.state

        return (
            <div className="personal-settings-header">
                <HeaderMessageContainer>
                    <PageTopMessage
                        kind="error"
                        showMessage={showErrorMessage}
                        onDismiss={() => this.setState({ showErrorMessage: false })}
                    >
                        {errorMessage}
                    </PageTopMessage>
                </HeaderMessageContainer>
                <Headline size={1}>{t('settings.personalSettings.header.title')}</Headline>
                <div className="personal-settings-header-row">
                    {uploading && <AvatarLoader />}
                    {!uploading && (
                        <label className="personal-settings-avatar-upload" htmlFor="avatarUpload">
                            <div className="personal-settings-avatar-frame">
                                <div
                                    className="personal-settings-avatar"
                                    style={{ backgroundImage: `url(${this.props.avatarUrl || NoAvatar})` }}
                                />
                            </div>
                            <span>{t('settings.personalSettings.header.changePhoto')}</span>
                        </label>
                    )}
                    {this.props.actions && (
                        <div className="personal-settings-header-actions">{this.props.actions}</div>
                    )}
                </div>
                <input
                    onChange={this.onFileSelected}
                    type="file"
                    accept="image/*"
                    id="avatarUpload"
                    style={{ display: 'none' }}
                />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators(
        {
            profileLoaded,
        },
        dispatch,
    )
}

export default connect(null, mapDispatchToProps)(AccountSettingsHeader)
